const auditTrailEntities = {
 'admin':  1,
 'auth':  2,
 'role':  3,
 'setting':  4,
 'tax_office':  5,
 'document':  6,
 'document_type':  7,
 'tag_type':  8,
 'workflow_item':  9,
  'workflow': 10,
  "workflow_item_approval": 11,
  "form_type": 12,
  "form_template": 13,
  "form_data": 14,
  "note": 15,
  "approval_workflow": 16,
  "case_type": 17,
  "case": 18,
  "relation_type": 19,
  "asset_type": 20,
  "tax_payer": 21,
  "individual": 22,
  "corporation": 23,
  "business_type": 24,
  "approval_item": 25,
  "workflow_item_activity": 26,
  "consultant": 27,
  "consultant_user": 28,
  "tax_audit": 29,
  "objection": 30,
  "relation": 31,
  "relation_link": 32,
  "income_type": 33,
  "assessment_group": 34,
  "corporation_payroll": 35,
  "tax_return": 36,
  "tax_return_document": 37,
  "bill": 38,
  "bill_recipient": 39,
  "tax_audit_type": 40,
  "tax_audit_team": 41,
  "tax_audit_team_member": 42,
  "tax_office_region": 43,
  "tax_audit_check_list_key": 44,
  "accommodation": 45,
  "consultant_tax_payer": 46,
  "relief": 47,
  "relief_type": 48,
  "tax_audit_confirmation": 49,
  "horc_return": 50,
  "horc_transaction_type": 51,
  "tcc": 52,
  "tcc_year": 53,
  "merge_request": 54,
  "property_clearance_request": 55,
  "property_clearance_request_tax_payer": 56,
};

export default auditTrailEntities;
